module.exports = __webpack_public_path__ + "src/assets/individualImages/honeyBeeWorkerSkinBlue.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/honeyBeeWorkerSkinBlue.png
// module id = ./src/assets/individualImages/honeyBeeWorkerSkinBlue.png
// module chunks = 0